module.exports = __webpack_public_path__ + "img/logo-ua.78086bc8.jpg";